/*------------------------------------*\
    MODULES
\*------------------------------------*/
import EmailValidation from "./modules/email-validation";
import Accordion from "./modules/accordion";
import CharacterCount from "./modules/character-count";
import ConsultationCountdown from "./modules/consultation-countdown";
import FeedbackProgressMorgan from "./modules/feedback-progress-morgan";
import FeedbackProgressMorecambe from "./modules/feedback-progress-morecambe";
import FeedbackProgressTransmission from "./modules/feedback-progress-transmission";
import FormReviewMorgan from "./modules/form-review-morgan";
import FormReviewMorecambe from "./modules/form-review-morecambe";
import FormReviewTransmission from "./modules/form-review-transmission";
import FormSave from "./modules/form-save";
import SiteHead from "./modules/site-head";
import TypeMate from "typemate";
import ZoomedImg from "./modules/zoomed-img";
import VideoModal from "./modules/video-modal";
import MapMorecambe from "./modules/map-morecambe";
import MapMorgan from "./modules/map-morgan";
import PasteWarning from "./modules/paste-warning";
import FormChangeTracker from "./modules/form-change-tracker";
import FieldValidation from "./modules/field-validation";

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {
    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {
        // Load any items that need modules
        let modulePlaceHolders = [
            ...document.querySelectorAll("[data-module]"),
        ];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {
            // Attempt to load any modules
            let modules = item.getAttribute("data-module");

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(",");

            // Loop and bind to relevant modules
            modules.map((module) => {
                switch (module.trim()) {
                    case 'character-count':

                        let characterCountInstance = new CharacterCount(item);

                        characterCountInstance.init();

                        break;

                    case "zoomed-image":
                        let zoomedImageInstance = new ZoomedImg(item);

                        zoomedImageInstance.init();

                        break;

                    case 'email-validation':

                        let emailValidationInstance = new EmailValidation;

                        emailValidationInstance.init();

                        break;

                    case "faq-accordion":

                        let faqAccordionInstance = new Accordion(item);

                        faqAccordionInstance.init();

                        break;

                    case 'feedback-progress':

                        let feedbackProgressInstance = new FeedbackProgress;

                        feedbackProgressInstance.init();

                        break;
                    
                    case 'field-validation':

                        let fieldValidationInstance = new FieldValidation(item);

                        fieldValidationInstance.init();

                        break;

                    case 'form-change-tracker':

                        let formChangeTrackerInstance = new FormChangeTracker(item);

                        formChangeTrackerInstance.init();

                        break;

                    case 'form-review':

                        formReviewMorganInstance.init();

                        break;

                    case "form-review-morecambe":
                        let formReviewMorecambeInstance =
                            new FormReviewMorecambe(item);

                        formReviewMorecambeInstance.init();

                        break;

                    case "form-review-transmission":
                        let formReviewTransmissionInstance =
                            new FormReviewTransmission(item);

                        formReviewTransmissionInstance.init();

                        break;

                    case "form-review-morgan":
                        let formReviewMorganInstance =
                            new FormReviewMorgan(item);

                        formReviewMorganInstance.init();

                        break;

                    case "form-save":
                        let formSaveInstance = new FormSave(item);

                        formSaveInstance.init();

                        break;

                    case 'paste-warning':

                        let pasteWarningInstance = new PasteWarning(item);

                        pasteWarningInstance.init();

                        break;

                    case 'site-head':

                        let siteHeadInstance = new SiteHead(item);

                        siteHeadInstance.init();

                        break;

                    case "feedback-progress-morgan":
                        let feedbackProgressMorganInstance =
                            new FeedbackProgressMorgan();

                        feedbackProgressMorganInstance.init();

                        break;

                    case "feedback-progress-morecambe":
                        let feedbackProgressMorecambeInstance =
                            new FeedbackProgressMorecambe();

                        feedbackProgressMorecambeInstance.init();

                        break;

                    case "feedback-progress-transmission":
                        let feedbackProgressTransmissionInstance =
                            new FeedbackProgressTransmission();

                        feedbackProgressTransmissionInstance.init();

                        break;

                    case "consultation-countdown":
                        let consultationCountdownInstance =
                            new ConsultationCountdown();

                        consultationCountdownInstance.init();

                        break;

                    case "video-modal":
                        let videoModalInstance = new VideoModal(item);

                        videoModalInstance.init();

                        break;

                    case "map-morecambe":
                        let mapMorecambeInstance = new MapMorecambe(item);

                        mapMorecambeInstance.init();

                        break;

                    case "map-morgan":
                        let mapMorganInstance = new MapMorgan(item);

                        mapMorganInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        // const typeMateInstance = new TypeMate();
        // typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove("no-js");
        document.documentElement.classList.add("js");
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    },
};

// Launch
app.init();
